import { LoadingOverlay, Stack } from '@mantine/core'
import Order from './components/Order'
import OrdersHeader from './components/OrdersHeader'
import React, { useEffect, useState } from 'react'
import { getOrders } from '../api/orderService'
import { OrderInterface } from '../typings/orderTypes'
import PageEmpty from '../components/PageEmpty'
import { getEnumByName } from '../api/dictionaryService'
import RightFloating from '../components/RightFloating'
import ComplaintButton from '../components/ComplaintButton'

export default function Orders() {
  const [orders, setOrders] = useState<OrderInterface[]>()
  const [statusMap, setStatusMap] = useState<Map<string, string>>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      try {
        const data = await getOrders()
        setOrders(data.filter((order) => order.status.toString() === '40'))
      } catch (error) {
        console.error('Failed to fetch orders:', error)
      }
    }

    const fetchStatusMap = async () => {
      try {
        const data = await getEnumByName('com.yuexiangcha.common.enumeration.IsaacOrderStatusEnum')
        setStatusMap(data)
      } catch (error) {
        console.error('Failed to fetch status map:', error)
      }
    }

    Promise.all([fetchData(), fetchStatusMap()]).finally(() => setLoading(false))
  }, [])

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        paddingTop: '20px',
        paddingBottom: '40px',
      }}
    >
      <div style={{ maxWidth: '640px', margin: '0 auto', padding: '0 16px' }}>
        <LoadingOverlay zIndex={1000} visible={loading} overlayProps={{ radius: 'sm', blur: 2 }} />

        {!loading && <OrdersHeader totalCount={orders?.length || 0} />}

        <Stack gap="md">
          {!loading && orders?.map((order) => <Order order={order} key={order.id} statusMap={statusMap!} />)}
        </Stack>

        {!loading && orders?.length === 0 && <PageEmpty />}
      </div>

      <RightFloating>
        <ComplaintButton className="rounded-l-lg" />
      </RightFloating>
    </div>
  )
}
